import { creative as creativeConstant } from 'content-creation-common/constants';
import { defineMessages } from 'react-intl';

export const { ALPHA_BLEND_MODES } = creativeConstant;

export const DEFAULT_ALPHA_BLEND_MODE = ALPHA_BLEND_MODES.SRC_OVER;

export const BLEND_MODE_ICON = {
  [ALPHA_BLEND_MODES.DST_ATOP]: 'maskdestatop',
  [ALPHA_BLEND_MODES.DST_IN]: 'maskdestin',
  [ALPHA_BLEND_MODES.DST_OUT]: 'maskdestout',
  [ALPHA_BLEND_MODES.DST_OVER]: 'maskdestover',
  [ALPHA_BLEND_MODES.SRC_ATOP]: 'masksrcatop',
  [ALPHA_BLEND_MODES.SRC_IN]: 'masksrcin',
  [ALPHA_BLEND_MODES.SRC_OUT]: 'masksrcout',
  [ALPHA_BLEND_MODES.SRC_OVER]: 'masksrcover',
  [ALPHA_BLEND_MODES.XOR]: 'maskxor',
};

export const BLEND_MODE_LABEL = defineMessages({
  [ALPHA_BLEND_MODES.DST_ATOP]: {
    defaultMessage: 'Destination Atop',
    description:
      'Option menu item, sets the alpha blend mode to Destination Atop - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.DST_IN]: {
    defaultMessage: 'Destination In',
    description:
      'Option menu item, sets the alpha blend mode to Destination In - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.DST_OUT]: {
    defaultMessage: 'Destination Out',
    description:
      'Option menu item, sets the alpha blend mode to Destination Out - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.DST_OVER]: {
    defaultMessage: 'Destination Over',
    description:
      'Option menu item, sets the alpha blend mode to Destination Over - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.SRC_ATOP]: {
    defaultMessage: 'Source Atop',
    description:
      'Option menu item, sets the alpha blend mode to  Source Atop - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.SRC_IN]: {
    defaultMessage: 'Source In',
    description:
      'Option menu item, sets the alpha blend mode to Source In - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.SRC_OUT]: {
    defaultMessage: 'Source Out',
    description:
      'Option menu item, sets the alpha blend mode to Source Out - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.SRC_OVER]: {
    defaultMessage: 'Source Over',
    description:
      'Option menu item, sets the alpha blend mode to Source Over (the default) - https://mzl.la/3Dy6gHa',
  },
  [ALPHA_BLEND_MODES.XOR]: {
    defaultMessage: 'Source Xor',
    description:
      'Option menu item, sets the alpha blend mode to Source Xor - https://mzl.la/3Dy6gHa',
  },
});

export const BLEND_MODE_TO_COMPOSITE_OPERATION = {
  [ALPHA_BLEND_MODES.DST_ATOP]: 'destination-atop',
  [ALPHA_BLEND_MODES.DST_IN]: 'destination-in',
  [ALPHA_BLEND_MODES.DST_OUT]: 'destination-out',
  [ALPHA_BLEND_MODES.DST_OVER]: 'destination-over',
  [ALPHA_BLEND_MODES.SRC_ATOP]: 'source-atop',
  [ALPHA_BLEND_MODES.SRC_IN]: 'source-in',
  [ALPHA_BLEND_MODES.SRC_OUT]: 'source-out',
  [ALPHA_BLEND_MODES.SRC_OVER]: 'source-over',
  [ALPHA_BLEND_MODES.XOR]: 'xor',
};
